"use client";
import React from "react";
import Heading from "@/components/molecules/Heading";

import { RichText as RichTextConverter } from "@payloadcms/richtext-lexical/react";
import BupiLink from "@/components/atoms/link";
import { InfoTextBlockProps } from "@/page-builder/fragments/InfoTextBlock/types";

const ModuloInfo = ({
  title,
  description,
  cta
}: InfoTextBlockProps) => {
  return (
    <section className="container mx-auto">
      <div className="grid grid-cols-1 gap-32 md:grid-cols-2">
        <Heading title={title} />
        
        <div className="grid grid-cols-1 gap-[20px]">
          <RichTextConverter
            className="text-m-regular text-neutral-900 whitespace-pre-line"
            data={description as any}
          />
          <div>
            {cta?.url && <BupiLink
              key={cta.label}
              label={cta.label}
              url={cta.url}
              target="_self"
              hasIcon
              className="py-16"
            /> }
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModuloInfo;
